import {useQuery, useMutation, useQueryClient} from "react-query";
import {getPrescriptions, deletePrescription, updatePrescription, savePrescription} from '../utils/api';
import {jwtDecode} from "jwt-decode";


const PRESCRIPTIONS_KEY = 'prescriptions';

const fetchPrescriptions = async (customerData, key, ims) => {
    const data = await getPrescriptions(
        customerData.email,
        customerData.accessToken,
        ims
    );
    if (!data || typeof data !== "object")
        throw new Error("Failed to fetch prescriptions");

    localStorage.setItem(`prescriptions_${key}`, JSON.stringify(data));
    return data;
};

export function usePrescriptions(customerData, ims) {

    const queryClient = useQueryClient();
     const decoded = customerData?.accessToken ? jwtDecode(customerData.accessToken) : null;
    const uid = decoded?.uid || customerData?.email || 'guest';
    const key = ["prescriptions", uid];

    const query = useQuery(
    key,
    () => fetchPrescriptions(customerData, uid, ims), // ← use uid
    {
        enabled: !!customerData?.accessToken && !!customerData?.email,
        onError: (error) => console.error("Failed to fetch prescriptions:", error),
        placeholderData: () => {
            const cached = localStorage.getItem(`prescriptions_${uid}`); // ← use uid
            return cached ? JSON.parse(cached) : undefined;
        },
        refetchOnMount: "always",
        refetchOnWindowFocus: true,
    }
);

    const save = useMutation(
        (newData) => savePrescription(customerData, newData, ims),
        {
            onSuccess: () => queryClient.invalidateQueries(key),
        }
    );

    const update = useMutation(
    ({ id, ...prescriptionData }) => updatePrescription(id, prescriptionData, ims),
    {
        onSuccess: () => queryClient.invalidateQueries(key),
    }
  );

    const remove = useMutation(
        async ({ id, fileUrl }) =>
            await deletePrescription(id, fileUrl, customerData.accessToken, ims),
        {
            onSuccess: () => queryClient.invalidateQueries(key),
        }
     );


    // const refresh = async () => {
    //     await queryClient.invalidateQueries(key);
    //     await queryClient.refetchQueries(key, {active: true});
    // };

    const refresh = () => query.refetch();

    return {...query, save, update, remove, refresh, refetch: query.refetch, };
}